"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.concat.js");
var _core = require("@lingui/core");
var _react = require("@lingui/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = _interopRequireWildcard(require("react"));
var _haBeehiveConnectorUtil = require("@adsk/ha-beehive-connector-util");
var _dataHelpers = require("@adsk/ha-beehive-connector-util/lib/BeehiveUtils/data-helpers");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var PublishDate = function PublishDate(_ref) {
  var text = _ref.text,
    upiLanguage = _ref.upiLanguage,
    language = _ref.language;
  var lang = language.replace('_', '-');
  (0, _react2.useEffect)(function () {
    _core.i18n.activate(lang);
  }, [lang]);
  var date = '';
  try {
    date = _haBeehiveConnectorUtil.beehiveDataHelpers.getDisplayDate(upiLanguage, lang, text);
  } catch (error) {
    // TBD: removing logger which may not be available when moving to HA
    console.error("PublishDate error with fields: ".concat(text, " ").concat(upiLanguage, " ").concat(language, " ").concat(lang));
  }
  return /*#__PURE__*/_react2.default.createElement(_react.I18nProvider, {
    i18n: _core.i18n
  }, date ? /*#__PURE__*/_react2.default.createElement("div", {
    className: "dhig-mb-4"
  }, /*#__PURE__*/_react2.default.createElement("p", {
    className: "MuiTypography-root MuiTypography-smallprint dhig-mb-4 dhig-typography dhig-typography-smallprint"
  }, date)) : null);
};
var _default = PublishDate;
exports.default = _default;
PublishDate.propTypes = {
  /**
   * Publish date string.
   */
  text: _propTypes.default.string,
  /**
   * The language for the UI. Must be in locale format i.e., en-US
   */
  language: _propTypes.default.string,
  /**
   * upi language
   */
  upiLanguage: _propTypes.default.string
};
PublishDate.defaultProps = {
  /**
   * Date returned by beehive data
   */
  text: '',
  /**
   * Default language to load for UI.
   */
  language: _dataHelpers.defaultLanguageCountry,
  /**
   * Default upi language.
   */
  upiLanguage: 'ENU'
};